<template>
  <div class="layout-product-certificate">
    <div
        v-for="(sertificat, index) in sertificates"
        :key="index"
        :class="[{ hidden: sertificat.rest2 && !opened }]"
        class="product-certificate"
    >
      <div>
        <div class="cerificatePicture">
          <img style="width: 100%;" :src="sertificat.src" :alt="sertificat.name">
        </div>
      </div>
      <div>
        <div class="cerificateText">
          <div class="blockDescriptions">
            <div class="itemDescription" v-html="sertificat.text"></div>
          </div>
        </div>
      </div>
      <div v-if="sertificat.rest2 && !opened" class="button-wrapper">
        <ui-button @click="opens()" small>Открыть</ui-button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    id:[],
    hidden: {
      type: Boolean,
      default: false
    }
  },
  components: {
    uiButton: () => import('@/components/ui/ui-button')
  },
  data() {
    return {
      opened: false,
      sertificates:[]
    }
  },
  methods: {
    opens(){
      this.opened = true;
    },
    async findSertificates(){
      const  sertificate  = (
          await this.$axios({
            url: '/ajax/sertificate-products.php',
            method: 'post',
            params: {
              SITE_ID: this.$store.state.siteid,
              id: this.id
            }
          })
      )
      if (sertificate) {
        this.sertificates = sertificate.data;
      } else {
        console.log('error hereLieDown')
      }
    },
  },
  mounted() {
    if (typeof (ym) === "function") {
      let yaCounterId = this.$store.state.langs.YACOUNTER;
      ym(yaCounterId, 'reachGoal', 'certificates_block_open');
    }

    if(!this.sertificates.length) {
      this.findSertificates();
    }
  }
}
</script>

<style lang="scss">
.product-certificate {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 20px;
  margin-bottom: 20px;
  --line-height: 20px;
  img {
    position: relative;
    top: 5px;
  }
  .cerificateText {
    line-height: var(--line-height);
  }
  &.hidden {
    .cerificateText {
      max-height: calc(var(--line-height) * 10);
      overflow: hidden;
    }
  }
  .button-wrapper {
    grid-column: 2/3;
  }
}
</style>
